import { FaArrowRight } from 'react-icons/fa'
import Image1 from '../../../assets/images/s8_image_1.png'
import Image2 from '../../../assets/images/s8_image_2.png'
import Image3 from '../../../assets/images/s8_image_3.png'
import Daun1 from '../../../assets/images/s8_daun_1.png'
import Daun2 from '../../../assets/images/s8_daun_2.png'

const Section8 = () => {
    return (
        <div className="w-full md:h-screen flex flex-col md:flex-row">
            <div className="w-full md:w-[60%] h-full flex flex-col items-start justify-center px-5 md:px-0 md:pl-10 relative py-5 md:py-0">
                <img src={Daun1} alt="Kebun Jitu" className='w-[200px] absolute md:right-4 md:top-16 hidden md:flex' loading='lazy'/>
                <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Latest Portfolio</h1>
                <p className="text-justify pb-5 text-sm md:text-start">
                    {/* Kebun Jitu has developed to make farming smarter, more efficient, and sustainable. */}
                    Kami percaya bahwa produktivitas pertanian yang lebih tinggi dimulai dari memahami kebutuhan tanah. Di Indonesia, banyak petani masih mengandalkan intuisi dalam mengelola lahan mereka, yang sering kali mengakibatkan hasil panen yang tidak optimal. Kami ingin mengubah itu dengan solusi berbasis data yang sederhana, praktis, dan langsung memberikan manfaat nyata bagi petani.
                </p>
                <button type='button' className=' text-white flex items-center justify-center gap-2 font-semibold'>
                    <span className='bg-custom-orange rounded-full px-5 py-2 capitalize'>Pelajari lebih lanjut</span>
                    <div className='rounded-full bg-custom-orange h-10 aspect-square flex items-center justify-center'>
                        <FaArrowRight />
                    </div>
                </button>
            </div>
            <div className="w-full md:w-[15%] h-full bg-black mt-5 md:mt-0 relative md:rounded-2xl ">
                <div className="w-full h-full bg-gradient-to-tr from-custom-green to-custom-green/30 flex items-center  justify-center gap-3 md:rounded-2xl pt-5 md:pt-0">
                    <img src={Image1} alt="Kebun Jitu" className='h-[300px] object-contain -ml-20' loading='lazy'/>
                    <div className='h-[200px] object-contain -mr-20 gap-3 flex flex-col'>
                        <img src={Image2} alt="Kebun Jitu" className='w-[200px]' loading='lazy'/>
                        <img src={Image3} alt="Kebun Jitu" className='w-[200px]' loading='lazy'/>
                    </div>
                </div>
            </div>
            <div className="w-full md:w-[25%] h-full relative overflow-hidden">
                <img src={Daun2} alt="Kebun Jitu" className='w-[500px] absolute -right-5 -bottom-16' loading='lazy' />
            </div>
        </div>
    )
}

export default Section8